import {
    FETCH_DASHBOARD_SUMMARY
} from './actionTypes';

const fetchDashboardSummary = (payload = {}) => {
    return({
        type: FETCH_DASHBOARD_SUMMARY,
        payload,
        errors: null
    });
}


export {
    fetchDashboardSummary
}